export default __webpack_public_path__ + "static/monitors-4f53986f7a40258b13ae8b2204d60384.png";